import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconPlayCircleComponent } from "./med-icon-play-circle.component";

@NgModule({
  declarations: [
    MedIconPlayCircleComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconPlayCircleComponent,
  ],
})
export class MedIconPlayCircleModule { }
